import { FC } from 'react'
import { dynamicRoutes } from '../../../../../constants/routes'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

interface EditProps {
    stampOrderDocId: string
}

const Edit: FC<EditProps> = ({ stampOrderDocId }) => {
    return (
        <Link to={dynamicRoutes.purchasesStampOrder(stampOrderDocId)}>
            <Button size={'small'} icon={<EditOutlined />} title={'Редактировать заказ штампа'} />
        </Link>
    )
}

export default Edit
